import React from "react";
import SearchableSelect from "./components/SearchableSelect";

const TaxonFilter = ({
  label,
  pluralLabel,
  options,
  unfilteredOptions,
  value,
  onChange,
}) => {
  return (
    <SearchableSelect
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      unfilteredOptions={unfilteredOptions}
      placeholder={`Select ${label.toLowerCase()}...`}
      allOptionLabel={`All ${pluralLabel}`}
      className="grow"
      posthogId={`filter-${label.toLowerCase()}`}
      posthogAttribute={`data-posthog-${label.toLowerCase()}`}
    />
  );
};

export default TaxonFilter;
